import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class NavService {

  public appDrawer: any;
  isHandset: boolean;

  public closeNav() {
    if (this.isHandset) {
      this.appDrawer.close();
    }
  }

  public openNav() {
    this.appDrawer.open();
  }
}
